import { ChevronRight } from "@hortis/ui/icons";
import { A, pipe } from "@mobily/ts-belt";
import type { Classification as ClassificationGql } from "generated/graphql";
import { colors } from "src/colors";

export const classificationRankOrder: Array<keyof ClassificationGql> = [
  "kingdom",
  "subkingdom",
  "phylum",
  "subphylum",
  "class",
  "subclass",
  "order",
  "superorder",
  "family",
  "subfamily",
  "tribe",
  "subtribe",
  "genus",
  "subgenus",
  "section",
  "subsection",
  "series",
  "subseries",
  "species",
  "subspecies",
  "infraspecies",
];

interface ClassificationProps {
  classification: ClassificationGql;
}

export const Classification = ({ classification }: ClassificationProps) => {
  const orderedClassification = pipe(
    classificationRankOrder,
    A.filter((name) => classification[name] != null),
    A.map((name) => classification[name]),
  );
  return (
    <div
      className="flex flex-wrap items-center gap-x-1.5"
      data-cy="classification"
    >
      {orderedClassification.map((name, idx) => (
        <>
          <div>{name}</div>
          {idx !== orderedClassification.length - 1 && (
            <ChevronRight size="16px" color={colors.grey[300]} />
          )}
        </>
      ))}
    </div>
  );
};
